import { SettingsIntegrationsActiveDirectoryDetailsComponent } from './components';
import { useActiveDirectoryFooter, useActiveDirectoryForm, useActiveDirectorySteps } from './hooks';

interface SettingsAdminActiveDirectoryDetailsContainerProps {
    activeDirectoryId?: string;
}

export const SettingsAdminActiveDirectoryDetailsContainer: React.FC<
    SettingsAdminActiveDirectoryDetailsContainerProps
> = ({ activeDirectoryId }) => {
    const {
        activeDirectory,
        formState,
        operatorsCustomFields,
        isDirty,
        isEditMode,
        loading,
        testConnectionState,
        identityProviderAttributes,
        pocFields,
        fieldErrors,
        handleChange,
        handleTestConnection,
        handleEditConnectionDetails,
        handleSave,
        handleClose,
    } = useActiveDirectoryForm({
        activeDirectoryId,
    });

    const { currentStep, headerTitle, getIsStepValid, handleBack, handleNext } = useActiveDirectorySteps({
        isEditMode,
        isDirty,
        testConnectionState,
        mappings: formState.mappings,
        identityProviderAttributes,
        pocFields,
    });

    const {
        isFooterPrimaryButtonDisabled,
        isFooterSecondaryButtonDisabled,
        footerPrimaryButtonText,
        footerSecondaryButtonText,
        handleFooterPrimaryButtonClick,
        handleFooterSecondaryButtonClick,
    } = useActiveDirectoryFooter({
        currentStep,
        handleNext,
        handleSave,
        handleClose,
        handleBack,
        loading,
        getIsStepValid,
        testConnectionState,
    });

    return (
        <SettingsIntegrationsActiveDirectoryDetailsComponent
            activeDirectory={activeDirectory}
            formState={formState}
            testConnectionState={testConnectionState}
            identityProviderAttributes={identityProviderAttributes}
            operatorsCustomFields={operatorsCustomFields}
            identityProviderMapping={formState.mappings}
            pocFields={pocFields}
            currentStep={currentStep}
            isDirty={isDirty}
            isEditMode={isEditMode}
            loading={loading}
            headerTitle={headerTitle}
            footerSecondaryButtonText={footerSecondaryButtonText}
            footerPrimaryButtonText={footerPrimaryButtonText}
            isFooterPrimaryButtonDisabled={isFooterPrimaryButtonDisabled}
            isFooterSecondaryButtonDisabled={isFooterSecondaryButtonDisabled}
            onFooterPrimaryButtonClick={handleFooterPrimaryButtonClick}
            onFooterSecondaryButtonClick={handleFooterSecondaryButtonClick}
            onChangeField={handleChange}
            fieldErrors={fieldErrors}
            onTestConnection={handleTestConnection}
            onEditConnectionDetails={handleEditConnectionDetails}
            onClose={handleClose}
        />
    );
};
